// ----------------------------------------------------------------------
// <copyright file="Izenda.Input.jsx" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS. </copyright>
// ----------------------------------------------------------------------

/**
 * Input Component
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isNil, omit, assign } from 'lodash/fp';

export default class Input extends Component {
  static displayName = 'Input';

  static propTypes = {
    indeterminate: PropTypes.bool, // Specific for the three state of input control
    isMasked: PropTypes.bool,
    shouldFocus: PropTypes.bool,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.any,
    type: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyPress: PropTypes.func,
    maxLength: PropTypes.any,
    autoComplete: PropTypes.string,
    focusCaller: PropTypes.func
  };

  /**
   * initial properties
   */
  static defaultProps = {
    containerClassName: 'col-md-10',
    className: 'form-control',
    name: '',
    type: 'text',
    value: '',
    onChange: undefined,
    onFocus: undefined,
    onKeyPress: undefined,
    disabled: false,
    isMasked: false,
    maxLength: 256
  };

  componentDidMount() {
    this.checkIndeterminate(this.props.indeterminate);
    this.props.shouldFocus && this.focusInput();
    this.props.focusCaller && this.props.focusCaller(this.focusInput);
  }

  focusInput = () => {
    this.input && this.input.focus();
  };

  /**
   * Set refs for component
   * @param {Object} dom object
   */
  setRef = (dom: any): void => {
    this.input = dom;
  };

  /**
   * Check indeterminate
   * @param {Boolean} indeterminate
   */
  checkIndeterminate(indeterminate: any): void {
    this.input.indeterminate = !!indeterminate;
  }

  componentDidUpdate() {
    this.checkIndeterminate(this.props.indeterminate);
  }

  render() {
    const { props } = this;
    const displayValue = !isNil(props.value) ? props.value : '';
    const value = props.isMasked ? '●●●●●●●●●●●●' : displayValue;
    const isCheckBox = props.type === 'checkbox' || props.type === 'radio';
    const isPassword = props.type === 'password' || props.type === 'text';

    let className = props.className;
    if (className === 'form-control' && isCheckBox) {
      className = '';
    }

    let rest = omit([
      'containerClassName',
      'className',
      'value',
      'indeterminate',
      'isMasked',
      'validateInfo',
      'checked',
      'validation',
      'shouldFocus',
      'autoComplete',
      'focusCaller'
    ], props);

    // Set up custom autocomplete value for type="password" inputs
    if (isPassword && !isNil(props.autoComplete)) {
      rest = assign(rest, {
        autoComplete: props.autoComplete
      });
    }

    // Omit maxLength props when maxLength = 'MAX'
    if (props.maxLength === 'MAX') {
      rest = omit(['maxLength'], rest);
    }

    return isCheckBox ? (
      <input className={className} checked={props.checked} {...rest} ref={this.setRef}/>
    ) : (
      <input className={className} value={value} {...rest} ref={this.setRef}/>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Input.js